<script setup>
</script>
<template>
  <div class="page-container new_article_design">
    <section class="blog-article-section">
      <article class="blog-article">
        <div class="container">
          <div class="single-article-wrapper">
            <div class="blog-post-date">November 18, 2024</div>
            <h1 class="article-title">
              Tools to power your trades and investments: November 2024
            </h1>
            <div class="article-cat">
              Blog |
              <a
                href="/market-talk/category/product-update/"
                rel="category tag"
                >PRODUCT UPDATE</a
              >
            </div>
            <div class="single-article-featured-img">
              <img
                width="937"
                height="534"
                src="https://upstox.com/app/uploads/2024/11/image-56.png"
                class="secondary-thumbnail"
                alt=""
                loading="lazy"
                srcset="
                  https://upstox.com/app/uploads/2024/11/image-56.png         937w,
                  https://upstox.com/app/uploads/2024/11/image-56-300x171.png 300w,
                  https://upstox.com/app/uploads/2024/11/image-56-768x438.png 768w,
                  https://upstox.com/app/uploads/2024/11/image-56-50x28.png    50w
                "
                sizes="(max-width: 937px) 100vw, 937px"
              />
            </div>
            <div class="single-article-content">
              <p>
                <span style="font-weight: 400"
                  >November marks a milestone for us with our biggest product
                  launch yet! Explore the TBT Engine and other exciting new
                  features we’ve added just for you 💜</span
                >
              </p>
              <p>
                <b><br /> </b
                ><strong>💜Major updates on ‘Upstox Pro for traders’</strong>
              </p>
              <p>
                <strong
                  ><br />
                  Leap into the future of trading with TBT Engine 🚀</strong
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  >We have utilised the power of true Tick-by-Tick data to
                  provide a host of features for you!</span
                >
              </p>
              <ul>
                <li>
                  <b>Order Flow Insights:</b
                  ><span style="font-weight: 400">
                    Know key information before placing a trade</span
                  >
                </li>
                <li>
                  <b>Depth Rank:</b
                  ><span style="font-weight: 400">
                    Understand where your order stands in the queue</span
                  >
                </li>
                <li>
                  <b>LIVE Alerts:</b
                  ><span style="font-weight: 400">
                    Get notified every 15 minutes if your depth rank
                    changes</span
                  >
                </li>
                <li>
                  <b>Market Depth 30:</b
                  ><span style="font-weight: 400">
                    Access bids and ask prices up to Depth 30</span
                  >
                </li>
                <li>
                  <b>Demand and Supply Zones:</b
                  ><span style="font-weight: 400">
                    Identify top orders with the highest quantities</span
                  >
                </li>
                <li>
                  <b>GTT Trigger Engine:</b
                  ><span style="font-weight: 400">
                    Experience reliable triggering of GTT orders</span
                  >
                </li>
                <li>
                  <b>Trade Price Checker:</b
                  ><span style="font-weight: 400">
                    See exactly how your order was matched</span
                  >
                </li>
              </ul>
              <p>
                <span style="font-weight: 400"
                  ><img
                    loading="lazy"
                    class="alignnone wp-image-49720 size-full"
                    src="https://upstox.com/app/uploads/2024/11/Tbt-logo.gif"
                    alt=""
                    width="600"
                    height="680"
                  /><br />
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  ><strong
                    >Redefine your mobile trading experience with the all-new
                    Chart360
                  </strong></span
                ><strong>📈📱<br /> </strong
                ><span style="font-weight: 400">Here’s how:</span>
              </p>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >Track both the underlying and Call/Put charts
                    together</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >Add OI data directly on the chart</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >Place trades or add stop-loss &amp; target directly from
                    the chart&nbsp;</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >Track your positions and P&amp;L with a single
                    swipe-up</span
                  >
                </li>
              </ul>
              <h4 id="_">
                <img
                  loading="lazy"
                  class="alignnone wp-image-49719 size-full"
                  src="https://upstox.com/app/uploads/2024/11/Chart-360-1.gif"
                  alt=""
                  width="600"
                  height="680"
                />
              </h4>
              <h4 id="significant-other-updates-%e2%ad%90">
                <strong
                  ><br />
                  Significant other updates ⭐</strong
                >
              </h4>
              <ul>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >P&amp;L Alerts and Payoff Graphs are now also available on
                    the Upstox web</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >Easily switch between NSE and BSE prices from the top-right
                    corner of the order placement window.</span
                  >
                </li>
                <li style="font-weight: 400" aria-level="1">
                  <span style="font-weight: 400"
                    >The Margin Calculator now has smart sequencing to know the
                    right sequence of placing your trades for the lowest
                    possible margin requirement.&nbsp;</span
                  >
                </li>
              </ul>
              <p>&nbsp;</p>
              <p><strong>Other recent updates:</strong></p>
              <p>
                <strong>💸 Margin Pledge</strong><b><br /> </b
                ><span style="font-weight: 400"
                  >Now pledge 5000+ Mutual Funds to get up to 90% margin for
                  F&amp;O and Equity Intraday trades</span
                >
              </p>
              <p>
                <strong>🚀 Margin Trading Facility (MTF)<br /> </strong
                ><span style="font-weight: 400"
                  >Now get up to ₹1.5 crore—3 times the earlier limit of ₹50
                  lakhs to invest and hold stocks for up to a year via
                  MTF.</span
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400">🆕 </span
                ><strong>More Ready-made Option Strategies</strong><b><br /> </b
                ><span style="font-weight: 400"
                  >Get curated strategies for new indices - FINNIFTY, MIDCAP,
                  BANKEX and SENSEX&nbsp;</span
                >
              </p>
              <p>
                <span style="font-weight: 400">⚡ </span
                ><strong>40% faster API Orders</strong><b><br /> </b
                ><span style="font-weight: 400"
                  >The new HFT endpoint has boosted the order execution speed by
                  40%</span
                >
              </p>
              <p>
                <strong
                  ><br />
                  Click
                  <a
                    href="/market-talk/tools-to-power-your-trades-and-investments-october-2024/"
                    >here</a
                  >
                  to read more about other recent updates.</strong
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  ><br />
                  That’s all folks! Hope these new features help you improve
                  your trading and investment journey. Our dev, product and
                  design teams have worked super hard to bring you these updates
                  – if you love them, don’t forget to share a review on
                  Playstore and App Store – it will make their day 🫶</span
                >
              </p>
              <p><strong>&nbsp;</strong></p>
            </div>
          </div>
        </div>
        <div class="download-App">
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/apple-icon.png"
                alt="apple-icon"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>iOS App</h3>
            </div>
          </a>
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/play-store-icon.png"
                alt="play-store"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>Android App</h3>
            </div>
          </a>
        </div>
      </article>
    </section>
  </div>
</template>
<style scoped>
</style>
